import { styled, Box, Typography } from '@mui/material';

export const Main = styled(Box, {
  shouldForwardProp: (props) => !['fullWidth'].includes(props),
})(({ fullWidth }) => ({
  width: '-webkit-fill-available',
  overflowY: 'auto',
}));

export const Next = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  padding: '24px 80px',
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'flex-end',
  zIndex: 2,
}));

export const BodyMediumMedium600 = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 14,
  color: theme.palette.grey['600'],
}));
export const DarkGreyTextLarge = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 16,
  color: theme.palette.grey['900'],
}));
